import React from 'react';
import { Link } from 'react-router-dom';
import { site } from '../data/site';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/1xiCDGXoxy8LwiKcxgW3pR/HomeRepairMD-logo.png';
type LogoProps = {
  badge?: boolean;
};
export function Logo({
  badge = false
}: LogoProps) {
  return <Link to="/" className={`inline-flex shrink-0 items-center ${badge ? 'rounded-2xl bg-white p-3' : ''}`} aria-label={`${site.name} home`} data-id="element-239" data-mp="3v8eews8fivn2">
      <img src={LOGO_SRC} alt={`${site.name} — ${site.license}`} className={badge ? 'h-28 w-auto' : 'h-[72px] w-auto'} data-id="element-240" data-mp="mqrrcwzkoxxh" />
    </Link>;
}